import { Component, OnInit, Input, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'legend-color-icon',
  templateUrl: './legend-color-icon.component.html',
  styleUrls: ['./legend-color-icon.component.css']
})
export class LegendColorIconComponent implements OnInit {
  @Input() color:string;

  @ViewChild("canvas") colorContainer:ElementRef;
  @ViewChild("img") imgContainer:ElementRef;
  
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // change the view, render the canvas
    let element = this.colorContainer.nativeElement as HTMLCanvasElement;
    let context = element.getContext("2d");
    context.fillStyle = this.color;
    context.fillRect(0, 0, element.width, element.height);
    let imgSrc = element.toDataURL("image/png");
    this.imgContainer.nativeElement.src = imgSrc;
    // now hide our current element
    element.className = "hidden";
  }

}



// WEBPACK FOOTER //
// ./src/app/assessment-charts/legend-color-icon/legend-color-icon.component.ts